import React, { useState } from 'react';
import FisioHeader from './components/FisioHeader';
import FisioHero from './components/FisioHero';
import FisioServices from './components/FisioServices';
import FisioWhyUs from './components/FisioWhyUs';
import FisioSchedule from './components/FisioSchedule';
import FisioContact from './components/FisioContact';

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return (
          <>
            <FisioHero setCurrentPage={setCurrentPage} />
            <FisioServices />
            <FisioWhyUs />
            <FisioSchedule />
            <FisioContact />
          </>
        );
      case 'services':
        return <FisioServices />;
      case 'about':
        return <FisioWhyUs />;
      case 'schedule':
        return <FisioSchedule />;
      case 'contact':
        return <FisioContact />;
      default:
        return (
          <>
            <FisioHero setCurrentPage={setCurrentPage} />
            <FisioServices />
            <FisioWhyUs />
            <FisioSchedule />
            <FisioContact />
          </>
        );
    }
  };

  return (
    <div className="font-sans antialiased text-gray-900">
      <FisioHeader setCurrentPage={setCurrentPage} />
      <main className="pt-16">
        {renderPage()}
      </main>
      <footer className="bg-gray-800 text-white py-8 text-center">
        <div className="container mx-auto px-4">
          <p>&copy; {new Date().getFullYear()} Fisio Life. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default App;

// DONE